export const productType = Object.freeze({
  VIRTUAL: 'VIRTUAL',
  CAR: 'CAR',
  REPAIR_ORDER: 'REPAIR_ORDER'
})
